// @flow
import { PeriodSurveysActionTypes } from './constants';

// import { APICore } from '../../helpers/api/apiCore';

// const api = new APICore();

const INIT_STATE = {
    periodSurvey: {},
    listaPeriodSurveys: [],
    loading: false,
    loadingForm: false,
    error: false,
    formSubmited: false
};

type PeriodSurveysAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};
type State = { periodSurvey?: {} | null, listaPeriodSurveys?: [] | null, loading?: boolean, +value ?: boolean };

const PeriodSurveys = (state: State = INIT_STATE, action: PeriodSurveysAction): any => {
    // console.log(action);
    switch (action.type) {
        case PeriodSurveysActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case PeriodSurveysActionTypes.GET_PERIOD_SURVEY: {
                    return {
                        ...state,
                        periodSurvey: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case PeriodSurveysActionTypes.LIST_PERIOD_SURVEYS: {
                    return {
                        ...state,
                        listaPeriodSurveys: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case PeriodSurveysActionTypes.ADD_PERIOD_SURVEY: {
                    return {
                        ...state,
                        error: false,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case PeriodSurveysActionTypes.UPDATE_PERIOD_SURVEY: {
                    return {
                        ...state,
                        error: false,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case PeriodSurveysActionTypes.DELETE_PERIOD_SURVEY: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case PeriodSurveysActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case PeriodSurveysActionTypes.GET_PERIOD_SURVEY: {
                    return {
                        ...state,
                        error: action.payload.error,
                        periodSurvey: {},
                        loading: false,
                    };
                }
                case PeriodSurveysActionTypes.LIST_PERIOD_SURVEYS: {
                    return {
                        ...state,
                        error: action.payload.error,
                        listaPeriodSurveys: [],
                        loading: false,
                    };
                }
                case PeriodSurveysActionTypes.ADD_PERIOD_SURVEY: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case PeriodSurveysActionTypes.UPDATE_PERIOD_SURVEY: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case PeriodSurveysActionTypes.DELETE_PERIOD_SURVEY: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case PeriodSurveysActionTypes.GET_PERIOD_SURVEY:
            return { ...state, error: false, loading: true };
        case PeriodSurveysActionTypes.LIST_PERIOD_SURVEYS:
            return { ...state, error: false, loading: true };
        case PeriodSurveysActionTypes.ADD_PERIOD_SURVEY:
            return { ...state, error: false, loadingForm: true };
        case PeriodSurveysActionTypes.UPDATE_PERIOD_SURVEY:
            return { ...state, error: false, loadingForm: true };
        case PeriodSurveysActionTypes.DELETE_PERIOD_SURVEY:
            return { ...state, error: false, loading: true };
        case PeriodSurveysActionTypes.RESET:
            return {
                ...state,
                loading: false,
                loadingForm: false,
                error: false,
                periodSurvey: {},
                listaPeriodSurveys: [],
                formSubmited: false
            };
        default:
            return { ...state };
    }
};

export default PeriodSurveys;
